<div class="page-contents" id="toplevelsub">
    <div class="subBlockContainer">
        <div class="breadcrumbWrapper">
            <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="blockContainer narrow-sidebar subBlockContainer_toplevel" id='levelOne'>
            <div class="combination-loader">
                <div class="child-sidebar">
                    <child-header title="Renewals" (closeEvent)="navigateTo('/home')" ></child-header>
                    <div class="child-body sidebar-loader">

                        <div class="page-title-wrapper">
                            <div class="title blade-title-font">
                                Current Renewals
                            </div>
                        </div>
                        <div class="menu-wrapper menu-font" [class.active]="selectedRenewals.startDate == currentRenewals.startDate && selectedRenewals.endDate == currentRenewals.endDate"
                            (click)="getRenewals(currentRenewals,renewalsCategories.currentRenewals)">
                            {{currentRenewals.month}}
                        </div>



                        <div class="page-title-wrapper">
                            <div class="title blade-title-font">
                                Upcoming Renewals
                            </div>
                        </div>
                        <ng-container *ngFor="let renewals of upcomingRenewals;index as i">
                            <div class="menu-wrapper menu-font" [class.active]="selectedRenewals.startDate == renewals.startDate && selectedRenewals.endDate == renewals.endDate"
                                (click)="getRenewals(renewals,renewalsCategories.upcomingRenewals,i)">
                                {{renewals.month}}
                            </div>
                        </ng-container>



                        <div class="page-title-wrapper">
                            <div class="title blade-title-font">
                                Expired Renewals
                            </div>
                        </div>
                        <ng-container *ngFor="let renewals of expiredRenewals;index as i">
                            <div class="menu-wrapper menu-font" [class.active]="selectedRenewals.startDate == renewals.startDate && selectedRenewals.endDate == renewals.endDate"
                                (click)="getRenewals(renewals,renewalsCategories.expiredRenewals,i)">
                                {{renewals.month}}
                            </div>
                        </ng-container>

                        <ng-container *ngIf="partnerProgramDetail">

                            <div class="page-title-wrapper">
                                <div class="title blade-title-font">
                                    Vendor Renewals
                                </div>
                            </div>

                            <div class="menu-wrapper menu-font" [class.active]="selectedPartnerProgram.out_vendor == partnerProgramDetail.out_vendor && selectedPartnerProgram.out_value == partnerProgramDetail.out_value"
                                (click)="getVendorRenwals(partnerProgramDetail)">
                                {{ partnerProgramDetail.out_vendor }}
                            </div>
                            
                        </ng-container>


                        <!-- <div class="menu-wrapper menu-wrapper-position"
                            [class.active]="isActive(renewalsCategories.currentRenewals)"
                            (click)="getRenewals(renewalsCategories.currentRenewals)">
                            <div class="total-div">
                                <div class="narrow-title">Current Renewals</div>
                                <span class="narrow-text">{{currentRenewals.month}}</span>
                            </div>
                        </div>

                        <div class="menu-wrapper menu-wrapper-position"
                            [class.active]="isActive(renewalsCategories.upcomingRenewals)"
                            (click)="getRenewals(renewalsCategories.upcomingRenewals)">
                            <div class="total-div">
                                <div class="narrow-title">Upcoming Renewals</div>
                                <ng-container *ngFor="let renewals of upcomingRenewals">
                                    <span class="narrow-text">{{renewals.month}}</span><br>
                                </ng-container>
                            </div>
                        </div>

                        <div class="menu-wrapper menu-wrapper-position"
                            [class.active]="isActive(renewalsCategories.expiredRenewals)"
                            (click)="getRenewals(renewalsCategories.expiredRenewals)">
                            <div class="total-div">
                                <div class="narrow-title" style="font-size: 12px;">Expired Renewals</div>
                                <ng-container *ngFor="let renewals of expiredRenewals">
                                    <span class="narrow-text">{{renewals.month}}</span><br>
                                </ng-container>
                            </div>
                        </div> -->

                    </div>

                </div>
                <div class="child-loader">
                    <router-outlet></router-outlet>
                 
                </div>
            </div>
        </div>
    </div>
</div>